<div class="box">
    <span class="title">What went Wrong?</span>
    <div class="inputs cg1">
        <div fxFlex="100" class="head">
            <ng-container *ngIf="!isCustomer">
                <label><b>Rejection Reason</b></label>
                <span>{{ requestResponse?.decline_reason?.reason }}</span>

                <label><b>Rejection Remark, if any</b></label>
                <span>{{ requestResponse?.remarks }}</span>
            </ng-container>

            <label><b>Rejected by</b></label>
            <span>{{ requestResponse?.declined_by?.first_name }} {{ requestResponse?.declined_by?.last_name }} on
                {{ requestResponse?.declined_at | date: 'dd MMM, yyyy' }}</span>
        </div>
    </div>
</div>

<div class="quoteHistory box" *ngIf="quoteHistoryList!=null">
    <span class="title">See what were quoted </span>
    <logzy-quote-history [getHistory]="forceRefresh" fxLayout="row wrap"></logzy-quote-history>
    <div class="inputs">
        <ng-container *ngIf="quoteHistoryList!=null">
            <logzy-review-quotation *ngIf="requestService.selectedRequest?.request_type?.dev_name!='lease'"
                                    [commercials]="quoteHistoryList" [reviewing]="false" [HeaderSet]="true"
                                    fxFlex="100"></logzy-review-quotation>
            <logzy-lease-review-quotation *ngIf="requestService.selectedRequest?.request_type?.dev_name=='lease'"
                                          [commercials]="quoteHistoryList" [reviewing]="false" [HeaderSet]="false"
                                          fxFlex="100"></logzy-lease-review-quotation>
        </ng-container>
    </div>
    <ng-container>
        <div fxLayout="column" class="w-100 shadoo " style="padding: 10px;">
            <span class="title">BOOKING CHARGES</span>
            <logzy-booking-charges (reqContainers)="showContainers($event)"
                                   [hideAddCharge]="true" [showActions]="false"></logzy-booking-charges>
        </div>
    </ng-container>
</div>
